module.exports = __webpack_public_path__ + "static/media/intro.ad632a44.mp3";